export const PROPOSALS_TABLE_HEADERS = [
  "Proposal ID",
  "Created",
  "User (Client)",
  "Account ID",
  "Target Portfolio",
  "Status",
  "Trade Details",
] as const;
